const docTypes = [
    'doc'
]

export default docTypes